import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { selectDefectToEdit } from "../../store/selectors/defectSelectors";
import { Dialog } from "primereact/dialog";
import { setToEdit } from "../../store/slices/defectSlice";
import { DefectForm } from "./DefectForm";

export const DefectDialog = () => {
    const dispatch = useAppDispatch();

    const toEdit = useAppSelector(selectDefectToEdit);

    if (!toEdit) {
        return null;
    }

    const onHide = () => {
        dispatch(setToEdit(undefined));
    };

    const header = toEdit.defectId ? "Edit Defect" : "Add Defect";

    return (
        <Dialog header={header} visible={!!toEdit} className="large-dialog" draggable={false} onHide={onHide}>
            <DefectForm defect={toEdit} onCancel={onHide} />
        </Dialog>
    )
}